import { Amplify } from 'aws-amplify'
import {
    Authenticator,
    ThemeProvider,
} from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css'

import cognitoSettingsQuery from './cognitoSettingsQuery'

import Router from './router'
import Header from './header'

const cognitoSettings = cognitoSettingsQuery()

const amplifyConfig = {
    Auth: {
        Cognito: {
            userPoolClientId: cognitoSettings.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
            userPoolId: cognitoSettings.REACT_APP_COGNITO_USER_POOL_ID,
            signUpVerificationMethod: "code",
            loginWith: {
                oauth: {
                    redirectSignIn: "https://localhost:3000/",
                    redirectSignOut: "https://localhost:3000/",
                    responseType: "code",
                    scopes: ['email', 'openid'],
                },
            },
        },
    },
}

Amplify.configure(amplifyConfig)

const components = {
    SignIn: {
        Header() {
            return (
                <div className="w-full flex flex-col items-center mt-6">
                    <img src="/logo.png" alt="Company Logo" className="w-80 h-auto" />
                    <p className="mt-4 text-lg text-gray-700 font-medium">Login as Client</p>
                </div>
            )
        },
    }
}

const amplifyTheme = {
    name: 'amplify-auth-theme',
    tokens: {
        components: {
            button: {
                primary: {
                    backgroundColor: { value: '#4F46E5' }, // Tailwind blue-600
                    color: { value: '#FFFFFF' },
                    _hover: {
                        backgroundColor: { value: '#4338CA' }, // Tailwind blue-700
                    },
                },
                link: {
                    color: { value: '#4F46E5' }, // Same as button bg
                    _hover: {
                        color: { value: '#4338CA' }, // Darker on hover
                    },
                },
            },
        },
    },
}

export default () => {

    return (
        <ThemeProvider theme={amplifyTheme}>
            <Authenticator hideSignUp components={components} >

                {() => (
                    <div className="min-h-screen flex flex-col bg-gray-50">

                        <Header />

                        <Router />

                    </div>

                )}
            </Authenticator>
        </ThemeProvider>
    )
}
